import { createSelector } from '@reduxjs/toolkit';

import { DataSourceType } from 'src/constants/dataSourceTypeDescription';
import { connectionSelector } from 'src/selectors/connection';
import { ReduxState } from 'src/store/types';

const dataSourcesTypeDescriptionByConnectionIdSelector = (state: ReduxState) =>
  state.dataSources.typeDescriptionByConnectionId;

export const dataSourceTypeListSelector = createSelector(
  connectionSelector,
  dataSourcesTypeDescriptionByConnectionIdSelector,
  (connection, typeDescriptionByConnectionId) => {
    const typeDescriptions = connection?.id
      ? typeDescriptionByConnectionId?.[connection.id]?.DATA_SOURCE_TYPES ||
        null
      : null;

    if (!typeDescriptions) {
      return new Set<DataSourceType>();
    }

    return Object.keys(typeDescriptions).reduce<Set<DataSourceType>>(
      (acc, key) => {
        const typeDescription = typeDescriptions[key];
        if (typeDescription && typeDescription.driverInstalled) {
          acc.add(key);
        }
        return acc;
      },
      new Set()
    );
  }
);
